export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20home%20theater%20room%20with%20large%20projector%20screen%20displaying%20abstract%20warm%20film%20texture%2C%20cozy%20dark%20atmosphere%20with%20soft%20amber%20light%20accents%2C%20film%20reel%20and%20vintage%20movie%20posters%20on%20wall%2C%20luxurious%20cinema%20lounge%20aesthetic%2C%20rich%20warm%20tones%20with%20deep%20shadows%2C%20atmospheric%20photography&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-screen-2xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-accent-500/90 text-white mb-6 whitespace-nowrap">
              每日更新 · 免费在线观看
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-4">
              木瓜影视
              <br />
              <span className="text-primary-300">你的免费在线高清影院</span>
            </h1>

            <p className="text-lg sm:text-xl text-white/80 font-light mb-3">
              打开网页就能看，无需下载，无需注册
            </p>

            <p className="text-sm sm:text-base text-white/60 max-w-xl mx-auto lg:mx-0 leading-relaxed mb-8">
              木瓜影视是一个完全免费的在线观看平台，汇聚2000+最新电视剧和热门电影高清资源。
              覆盖悬疑、古装、都市、科幻、动作、喜剧等全品类内容，每日持续更新热播新剧，
              即点即播无需等待，高清画质不缓冲，是你追剧看片的最佳选择。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-300">2000+</div>
                <div className="text-xs text-white/50 mt-1">高清影视资源</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-300">500万+</div>
                <div className="text-xs text-white/50 mt-1">忠实观众</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-300">每日更新</div>
                <div className="text-xs text-white/50 mt-1">热剧同步上线</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 hover:bg-primary-600 text-white font-semibold text-base whitespace-nowrap transition-all cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-white/30 hover:border-white/60 text-white font-medium text-base whitespace-nowrap transition-all cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                热度榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-xl">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20collage%20of%20popular%20Chinese%20film%20and%20TV%20drama%20posters%20arranged%20artistically%2C%20warm%20cinematic%20color%20palette%20with%20amber%20and%20crimson%20tones%2C%20artistic%20flat%20lay%20composition%20with%20film%20reel%20and%20popcorn%2C%20modern%20cinema%20aesthetic%2C%20rich%20contrast%20and%20grain%20texture&width=800&height=1000&seq=hero-visual&orientation=portrait"
                alt="木瓜影视热门影视合集 - 最新电视剧电影高清在线观看"
                className="w-full h-auto object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-5">
                <p className="text-white/90 text-sm font-medium">每周精选片单 · 热播新剧抢先看</p>
                <p className="text-white/60 text-xs mt-1">即点即播 · 高清不缓冲 · 免费在线直接看</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}